/**
 * Bundle add-on price sync. Cart adds for checked .ea-addon inputs are handled by
 * assets/sf-addons.js (after the bouquet is added, with a "For" property).
 *
 * Keeps the "Add to cart - $X" button text in sync with checked add-ons: the theme
 * only ever prices that button off the selected variant (blocks/buy-buttons.liquid), with
 * no awareness of these extra line items, so toggling an add-on previously left the button
 * showing the bouquet's price alone. Re-derives the true base price from the variant-picker's
 * own embedded variant JSON (assets/variant-picker.js keeps it live on every selection change)
 * rather than by parsing the button's own text, since after a variant change the theme morphs
 * the button back to the bare variant price — this file's own additions must never be mistaken
 * for that base on the next recalculation.
 */
(function () {
  // Adding checked add-ons to the cart now lives in assets/sf-addons.js. The submit handler
  // that used to be here looked for .ea-addon inputs inside the <form>, but the add-on blocks
  // render outside it, so nothing was ever added. This file now only syncs the button price.

  // --- Add to cart button price sync -------------------------------------------------

  function getButtonTextNode(button) {
    for (var i = 0; i < button.childNodes.length; i++) {
      var node = button.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) return node;
    }
    return null;
  }

  // Splits e.g. "Add to cart - $130.00" into { prefix: "Add to cart - $", suffix: "" } so the
  // recomputed total can be re-inserted in place without hardcoding the translated label,
  // currency symbol, or its position.
  function parseMoneyFormat(sample) {
    var match = sample.match(/([^\d]*)([\d.,]*\d)([^\d]*)$/);
    if (!match) return null;
    var numeric = match[2];
    var lastComma = numeric.lastIndexOf(',');
    var lastDot = numeric.lastIndexOf('.');
    var decimalSep = lastComma > lastDot ? ',' : '.';
    var thousandSep = decimalSep === '.' ? ',' : '.';
    return { prefix: match[1], suffix: match[3], decimalSep: decimalSep, thousandSep: thousandSep };
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, format.thousandSep);
    var numeric = whole + format.decimalSep + parts[1];
    return format.prefix + numeric + format.suffix;
  }

  function updateAddToCartPrice(button, scope) {
    if (!button) return;
    var textNode = getButtonTextNode(button);
    if (!textNode) return;

    if (!button._eaMoneyFormat) {
      button._eaMoneyFormat = parseMoneyFormat(textNode.textContent) || false;
    }
    var format = button._eaMoneyFormat;
    if (!format) return; // Button has no price in its text (show_price_in_button is off).

    var baseCents = null;
    var jsonScript = scope.querySelector('variant-picker script[type="application/json"]');
    if (jsonScript) {
      try {
        var parsed = JSON.parse(jsonScript.textContent);
        if (parsed && typeof parsed.price === 'number') baseCents = parsed.price;
      } catch (e) {
        /* ignore malformed/missing variant JSON, fall through to cached base below */
      }
    }
    if (baseCents !== null) {
      button.dataset.eaBaseCents = String(baseCents);
    } else if (button.dataset.eaBaseCents !== undefined) {
      baseCents = Number(button.dataset.eaBaseCents);
    } else {
      return; // No variant-picker and no prior base captured — nothing reliable to add to.
    }

    var addonCents = 0;
    var checkedAddons = scope.querySelectorAll('.ea-addon:checked');
    checkedAddons.forEach(function (el) {
      addonCents += Number(el.getAttribute('data-price')) || 0;
    });

    var newText = formatMoney(baseCents + addonCents, format);
    if (textNode.textContent !== newText) {
      textNode.textContent = newText;
    }
  }

  function setupPriceSync(scope) {
    var addons = scope.querySelectorAll('.ea-addon');
    // A product page's shopify-section holds more than one "[ref=addToCartButton]" — the main
    // form's button and the mobile sticky-bar's compact button both live in it — so every one
    // of them needs its own sync, not just whichever the section's first querySelector happens
    // to return (confirmed live: that was the sticky bar's button, whose price sits inside
    // nested spans rather than a direct text node, so getButtonTextNode found nothing there and
    // the fix silently never touched the main button at all).
    var buttons = scope.querySelectorAll('[ref="addToCartButton"]');
    if (!addons.length || !buttons.length) return;

    function updateAll() {
      buttons.forEach(function (button) {
        updateAddToCartPrice(button, scope);
      });
    }

    addons.forEach(function (input) {
      input.addEventListener('change', updateAll);
    });

    // Each button's price text is morphed back to the bare variant price on every variant
    // change (assets/product-form.js); re-apply the add-on total whenever that happens.
    buttons.forEach(function (button) {
      new MutationObserver(function () {
        updateAddToCartPrice(button, scope);
      }).observe(button, { characterData: true, childList: true, subtree: true });
    });

    updateAll();
  }

  document.querySelectorAll('.shopify-section').forEach(function (section) {
    if (section.querySelector('.ea-addon')) setupPriceSync(section);
  });
})();
